/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum StreamEventType {
    // Legacy event types kept for backward compatibility

    PROGRESS = "progress",
    CHUNK = "chunk",
    RESULT = "result",
    ERROR = "error",

    // new event types
    TASKS = "tasks",
    MESSAGE_START = "message_start",
    MESSAGE_DELTA = "message_delta",
    MESSAGE_END = "message_end",
    TASK_START = "task_start",
    TASK_PROGRESS = "task_progress",
    TASK_OUTPUT = "task_output",
    TASK_ERROR = "task_error",
    TASK_COMPLETE = "task_complete",
    AGENT_SUMMARY = "agent_summary",
    FINAL_RESULT = "final_result",
    SYSTEM_ERROR = "system_error",
    COMPLETE = "complete",

    // Keepalive: content-free frame proving the stream is alive
    HEARTBEAT = "heartbeat",

    // Deadline event types
    CONTINUATION_REQUIRED = "continuation_required",
    TIMEOUT = "timeout",

    // Authorization event types
    AUTHORIZATION_REQUIRED = "authorization_required",
    AUTHORIZATION_APPROVED = "authorization_approved",
    AUTHORIZATION_DENIED = "authorization_denied",
    AUTHORIZATION_EXPIRED = "authorization_expired"



}
